import Vue from 'vue';
import Buefy from 'buefy';
import CustomHome from './App.vue';

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(CustomHome)

if(document.getElementById("customHeroApp")){
    new Vue({
        render:h=>h(
            CustomHome,{
                props:{
                    primaryColor:document.getElementById("customHeroApp")
                        .getAttribute("primary-color"),
                    htmlCode:document.getElementById("customHeroApp")
                        .getAttribute("html-code"),
                    cssCode:document.getElementById("customHeroApp")
                        .getAttribute("css-code"),
                    jsCode:document.getElementById("customHeroApp")
                        .getAttribute("js-code"),
                    userAuth: document.getElementById("customHeroApp")
                        .getAttribute("user-auth"),
                    userName: document.getElementById("customHeroApp")
                        .getAttribute("user-name"),
                    userEmail: document.getElementById("customHeroApp")
                        .getAttribute("user-email"),
                }
            }
        )
    }).$mount("#customHeroApp")
}